module.exports = __webpack_public_path__ + "img/stock0.6748cf72.png";